import React from 'react'

import { ProductImage } from 'app/common/Common'
import { PixelCurrency } from 'pixel-base'
import styled from 'styled-components'
import { HeaderTitle, TableHeader } from './MergeOrders'
import { LineItem } from '../../../../decl.d'
import {
  InlineSection,
  ProductName,
} from '../OrderDetails/components/subComponents/ProductLineItem'

interface IProps {
  item: LineItem
  index: number
}

const LineItems = (props: IProps) => {
  const { item, index } = props
  const truncate = (label, max) => {
    return label?.length > max ? label.substr(0, max - 1) + '...' : label
  }
  return (
    <Container>
      {index === 0 && (
        <TableHeader>
          <HeaderTitle width={'65%'}>Product</HeaderTitle>
          <HeaderTitle width={'15%'}>Qty</HeaderTitle>
          <HeaderTitle width={'20%'}>Total</HeaderTitle>
        </TableHeader>
      )}
      <Product>
        <ProductDetails>
          <ProductImage path={item.image} />
          <ProductSection>
            <ProductName style={{ fontSize: '12px' }}>
              {truncate(item.name, 105)}
            </ProductName>
            <InlineSection>SKU: {item.sku}</InlineSection>
            <InlineSection>
              Price: <PixelCurrency value={item.price} />
            </InlineSection>
          </ProductSection>
        </ProductDetails>
        <Quantity>
          <InlineSection>{item.quantity}</InlineSection>
        </Quantity>
        <Total>
          <InlineSection>
            <PixelCurrency value={item.quantity * item.price} />
          </InlineSection>
        </Total>
      </Product>
    </Container>
  )
}
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-bottom: 1px solid #e5e5e5;
`
export const Product = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  gap: 10px;
  padding: 5px;
  height: 90px;
`
const ProductDetails = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  align-content: flex-start;
  width: 70%;
  gap: 10px;
`
const ProductSection = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: center;
  gap: 2px;
  width: 100%;
  /* padding: 10px 0px; */
`
const Quantity = styled.div`
  width: 10%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
`
const Total = styled.div`
  width: 20%;
  display: flex;
  flex-direction: row;
`

export default LineItems
